import React from 'react'

import { Box, Card, CircleLoader, Flex, Link, Text } from '@driftt/dds'

import StatusIcon from 'components/StatusIcon'
import useFetchVisitors from 'hooks/useFetchVisitors'
import { formatCompactNumber } from 'utils/formatNumbers'

export interface LiveVisitorsCardProps {
  hasLiveViewFromReach: boolean
}

const LiveVisitorsCard = ({ hasLiveViewFromReach }: LiveVisitorsCardProps) => {
  const { data } = useFetchVisitors({ requestSize: 250, hasLiveViewFromReach })
  return (
    <Flex
      direction="column"
      justifyContent="flex-end"
      alignItems="flex-end"
      css={{ position: 'relative' }}
      fullWidth
      gap={4}>
      <Card
        css={{
          padding: '$2',
          height: '100%',
          maxWidth: '300px',
          width: '100%',
          overflowX: 'hidden'
        }}>
        <Flex gap="half" alignItems="center" justifyContent="space-between">
          {data ? (
            <>
              <Box css={{ witdh: '40px' }}>
                <StatusIcon />
              </Box>
              <Flex
                gap={1}
                alignItems="center"
                css={{
                  overflowX: 'hidden'
                }}>
                <Text variant="bodyBold">{formatCompactNumber(data?.resultSetSize)}</Text>
                <Text variant="bodyBold" truncate>
                  Live visitors on your site
                </Text>
              </Flex>

              <Link
                css={{
                  fontWeight: '$normal'
                }}
                variant="inline"
                href="/live"
                target="_blank">
                View all
              </Link>
            </>
          ) : (
            <Flex
              alignItems="center"
              justifyContent="space-evenly"
              direction="column"
              fullHeight
              fullWidth>
              <CircleLoader size="extra-large" variant="dark" />
            </Flex>
          )}
        </Flex>
      </Card>
    </Flex>
  )
}

export default LiveVisitorsCard
